import { useContext } from 'react'
import { Navigate, Outlet } from 'react-router'
import './Settings.css'
import PageContent from '../../ui/PageContent'
import SettingsNav from './SettingsNav'
import { ProjectRoleRequired } from '../project/ProjectRoleRequired'
import { useTranslation } from 'react-i18next'
import { ProjectContext } from '../../contexts'
import { checkProjectRole } from '../../utils'
import ProjectSettings from './ProjectSettings'

export function SettingsIndex() {
    const [project] = useContext(ProjectContext)

    return checkProjectRole('admin', project.role)
        ? <ProjectSettings />
        : <Navigate to="integrations" replace />
}

export default function Settings() {
    const { t } = useTranslation()

    return (
        <ProjectRoleRequired minRole="developer">
            <PageContent title={t('settings')} fullscreen>
                <div className="settings-layout">
                    <SettingsNav />
                    <div className="settings-content">
                        <Outlet />
                    </div>
                </div>
            </PageContent>
        </ProjectRoleRequired>
    )
}
